
// // import React, { useState, useEffect } from 'react';
// // import styled, { keyframes } from 'styled-components';
// // import { motion, AnimatePresence } from 'framer-motion';
// // import { 
// //   FaUsers, FaRocket, FaHeart, FaShieldAlt, 
// //   FaLightbulb, FaHandshake, FaAward, FaChartLine 
// // } from 'react-icons/fa';
// // import { getAboutContent } from '../services/aboutService';
// // import companyFounder from "../images/companyfounder.jpg";

// // // Animations
// // const fadeInUp = keyframes`
// //   from {
// //     opacity: 0;
// //     transform: translateY(40px);
// //   }
// //   to {
// //     opacity: 1;
// //     transform: translateY(0);
// //   }
// // `;

// // const gradientShift = keyframes`
// //   0% {
// //     background-position: 0% 50%;
// //   }
// //   50% {
// //     background-position: 100% 50%;
// //   }
// //   100% {
// //     background-position: 0% 50%;
// //   }
// // `;

// // const float = keyframes`
// //   0%, 100% {
// //     transform: translateY(0px);
// //   }
// //   50% {
// //     transform: translateY(-20px);
// //   }
// // `;

// // // Styled Components
// // const PageContainer = styled.div`
// //   padding: 120px 20px 80px;
// //   max-width: 1400px;
// //   margin: 0 auto;
// //   min-height: 100vh;
// //   background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
// //   position: relative;
  
// //   &::before {
// //     content: '';
// //     position: absolute;
// //     top: 0;
// //     left: 0;
// //     right: 0;
// //     height: 1px;
// //     background: linear-gradient(90deg, transparent, #e2e8f0, transparent);
// //   }
// // `;

// // const HeroSection = styled(motion.section)`
// //   text-align: center;
// //   margin-bottom: 80px;
// //   padding: 80px 40px;
// //   background: linear-gradient(135deg, #0A2342 0%, #005f56 50%, #0A2342 100%);
// //   border-radius: 24px;
// //   color: #FFFFFF;
// //   position: relative;
// //   overflow: hidden;
// //   box-shadow: 0 20px 40px rgba(10, 35, 66, 0.3);

// //   &::before {
// //     content: '';
// //     position: absolute;
// //     top: 0;
// //     left: 0;
// //     right: 0;
// //     bottom: 0;
// //     background: 
// //       radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.1) 0%, transparent 50%),
// //       radial-gradient(circle at 80% 20%, rgba(255, 200, 87, 0.1) 0%, transparent 50%);
// //     background-blend-mode: overlay;
// //   }

// //   @media (max-width: 768px) {
// //     padding: 60px 20px;
// //     margin-bottom: 60px;
// //   }
// // `;

// // const Title = styled.h1`
// //   font-size: clamp(2.5rem, 5vw, 4rem);
// //   font-weight: 800;
// //   margin-bottom: 20px;
// //   letter-spacing: -0.02em;
// //   position: relative;
// //   z-index: 2;
  
// //   span {
// //     display: block;
// //     font-size: clamp(1rem, 2vw, 1.5rem);
// //     color: #FFC857;
// //     margin-top: 1rem;
// //     font-weight: 600;
// //     letter-spacing: 0.3em;
// //     text-transform: uppercase;
// //     background: linear-gradient(135deg, #FFC857, #FF9F1C);
// //     -webkit-background-clip: text;
// //     -webkit-text-fill-color: transparent;
// //     background-clip: text;
// //   }
// // `;

// // const Subtitle = styled.p`
// //   font-size: clamp(1.1rem, 2vw, 1.4rem);
// //   color: rgba(244, 244, 244, 0.95);
// //   max-width: 700px;
// //   margin: 0 auto;
// //   line-height: 1.6;
// //   font-weight: 300;
// //   position: relative;
// //   z-index: 2;
// // `;
// // const ImageContainer = styled(motion.div)`
// //   position: relative;
// //   overflow: hidden;
// //   border-radius: 20px;
// //   box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
// //   background: #ffffff;

// //   img {
// //     width: 100%;
// //     height: auto;
// //     display: block;
// //     border-radius: 20px;
// //     transition: transform 0.4s ease;
// //   }

// //   &:hover img {
// //     transform: scale(1.05);
// //   }

// //   @media (max-width: 768px) {
// //     max-width: 100%;
// //     margin: 0 auto;
// //   }
// // `;


// // const ContentSection = styled(motion.section)`
// //   margin-top: 40px;
// // `;

// // const Section = styled(motion.div)`
// //   margin-bottom: 100px;
// //   padding: 0 20px;

// //   @media (max-width: 768px) {
// //     margin-bottom: 80px;
// //   }
// // `;

// // const SectionTitle = styled.h2`
// //   font-size: clamp(2rem, 4vw, 3rem);
// //   color: #0A2342;
// //   margin-bottom: 50px;
// //   text-align: center;
// //   position: relative;
// //   font-weight: 800;
// //   letter-spacing: -0.02em;
  
// //   &::after {
// //     content: '';
// //     position: absolute;
// //     bottom: -20px;
// //     left: 50%;
// //     transform: translateX(-50%);
// //     width: 80px;
// //     height: 4px;
// //     background: linear-gradient(to right, #0A2342, #00A896);
// //     border-radius: 2px;
// //   }
// // `;

// // const SectionContent = styled.div`
// //   display: grid;
// //   grid-template-columns: ${props => props.reverse ? '1fr 1.2fr' : '1.2fr 1fr'};
// //   gap: 60px;
// //   align-items: center;
// //   max-width: 1200px;
// //   margin: 0 auto;

// //   @media (max-width: 1024px) {
// //     gap: 40px;
// //   }

// //   @media (max-width: 768px) {
// //     grid-template-columns: 1fr;
// //     gap: 40px;
// //   }
// // `;

// // const TextContent = styled.div`
// //   color: #475569;
// //   line-height: 1.8;
// //   font-size: 1.15rem;
// //   font-weight: 400;

// //   p {
// //     margin-bottom: 1.5rem;
    
// //     &:last-child {
// //       margin-bottom: 0;
// //     }
// //   }

// //   strong {
// //     color: #0A2342;
// //     font-weight: 700;
// //   }

// //   em {
// //     color: #00A896;
// //     font-style: normal;
// //     font-weight: 600;
// //   }
// // `;

// // const ValuesGrid = styled.div`
// //   display: grid;
// //   grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
// //   gap: 40px;
// //   margin-top: 50px;
// //   max-width: 1200px;
// //   margin: 50px auto 0;

// //   @media (max-width: 768px) {
// //     grid-template-columns: 1fr;
// //     gap: 30px;
// //   }
// // `;

// // const ValueCard = styled(motion.div)`
// //   background: #ffffff;
// //   padding: 50px 40px;
// //   border-radius: 20px;
// //   text-align: center;
// //   box-shadow: 
// //     0 10px 30px rgba(0, 0, 0, 0.08),
// //     0 0 0 1px rgba(0, 0, 0, 0.03);
// //   border-top: 4px solid #00A896;
// //   transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
// //   position: relative;
// //   overflow: hidden;

// //   &::before {
// //     content: '';
// //     position: absolute;
// //     top: 0;
// //     left: -100%;
// //     width: 100%;
// //     height: 100%;
// //     background: linear-gradient(90deg, transparent, rgba(0, 168, 150, 0.05), transparent);
// //     transition: left 0.6s ease;
// //   }

// //   &:hover {
// //     transform: translateY(-8px);
// //     box-shadow: 
// //       0 25px 50px -12px rgba(0, 0, 0, 0.15),
// //       0 0 0 1px rgba(0, 0, 0, 0.03);

// //     &::before {
// //       left: 100%;
// //     }

// //     .value-icon {
// //       transform: scale(1.1) rotate(5deg);
// //       color: #00A896;
// //       animation: ${float} 3s ease-in-out infinite;
// //     }
// //   }
// // `;

// // const ValueIcon = styled.div`
// //   font-size: 3.5rem;
// //   color: #0A2342;
// //   margin-bottom: 25px;
// //   transition: all 0.4s ease;
// // `;

// // const ValueTitle = styled.h3`
// //   color: #0A2342;
// //   margin-bottom: 20px;
// //   font-size: 1.5rem;
// //   font-weight: 700;
// // `;

// // const ValueDescription = styled.p`
// //   color: #64748b;
// //   line-height: 1.7;
// //   font-size: 1.05rem;
// //   font-weight: 400;
// // `;

// // const StatsSection = styled(Section)`
// //   background: linear-gradient(135deg, #0A2342 0%, #005f56 100%);
// //   color: white;
// //   padding: 80px 40px;
// //   border-radius: 24px;
// //   margin: 100px auto;
// //   max-width: 1200px;
// //   text-align: center;
// //   position: relative;
// //   overflow: hidden;

// //   &::before {
// //     content: '';
// //     position: absolute;
// //     top: 0;
// //     left: 0;
// //     right: 0;
// //     bottom: 0;
// //     background: url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Cpath d='m0 40l40-40h-40v40zm40 0v-40h-40l40 40z'/%3E%3C/g%3E%3C/svg%3E");
// //   }

// //   @media (max-width: 768px) {
// //     padding: 60px 20px;
// //     margin: 80px auto;
// //   }
// // `;

// // const StatsGrid = styled.div`
// //   display: grid;
// //   grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
// //   gap: 50px;
// //   margin-top: 50px;
// //   position: relative;
// //   z-index: 2;

// //   @media (max-width: 768px) {
// //     grid-template-columns: repeat(2, 1fr);
// //     gap: 40px;
// //   }
// // `;

// // const StatItem = styled(motion.div)`
// //   text-align: center;
  
// //   .stat-number {
// //     font-size: 3.5rem;
// //     font-weight: 800;
// //     color: #FFC857;
// //     margin-bottom: 10px;
// //     display: block;
// //     line-height: 1;
// //   }
  
// //   .stat-label {
// //     font-size: 1.2rem;
// //     color: rgba(255, 255, 255, 0.9);
// //     font-weight: 500;
// //   }
// // `;

// // const TeamSection = styled(Section)`
// //   text-align: center;
// // `;

// // const TeamContent = styled.div`
// //   max-width: 800px;
// //   margin: 0 auto;
// // `;

// // const LoadingContainer = styled.div`
// //   display: flex;
// //   justify-content: center;
// //   align-items: center;
// //   min-height: 60vh;
// //   flex-direction: column;
// //   gap: 20px;
// // `;

// // const LoadingSpinner = styled.div`
// //   width: 50px;
// //   height: 50px;
// //   border: 4px solid #f3f3f3;
// //   border-top: 4px solid #00A896;
// //   border-radius: 50%;
// //   animation: spin 1s linear infinite;

// //   @keyframes spin {
// //     0% { transform: rotate(0deg); }
// //     100% { transform: rotate(360deg); }
// //   }
// // `;

// // const LoadingMessage = styled.div`
// //   text-align: center;
// //   color: #64748b;
// //   font-size: 1.2rem;
// //   font-weight: 500;
// // `;

// // const ErrorMessage = styled.div`
// //   text-align: center;
// //   padding: 60px 40px;
// //   background: #ffffff;
// //   border-radius: 20px;
// //   box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
// //   max-width: 600px;
// //   margin: 100px auto;

// //   h2 {
// //     color: #dc3545;
// //     margin-bottom: 20px;
// //     font-size: 1.8rem;
// //     font-weight: 700;
// //   }

// //   p {
// //     color: #64748b;
// //     font-size: 1.1rem;
// //     line-height: 1.6;
// //   }
// // `;

// // // Default content in case API fails
// // const defaultAboutContent = {
// //   title: "About VVV IT Solutions",
// //   subtitle: "Pioneering digital transformation through innovative technology solutions",
// //   sections: [
// //     {
// //       title: "Our Story",
// //       content: `Founded with a vision to revolutionize the digital landscape, VVV IT Solutions has emerged as a trusted partner for businesses seeking cutting-edge technology solutions. Our journey began with a simple yet powerful mission: to bridge the gap between complex business challenges and innovative technological solutions.\n\nOver the years, we've grown from a small startup to a comprehensive IT solutions provider, serving clients across various industries. Our commitment to excellence and customer satisfaction has been the driving force behind our success.`,
// //       imageUrl: "/images/about-story.jpg"
// //     },
// //     {
// //       title: "Our Mission",
// //       content: `At VVV IT Solutions, our mission is to empower businesses with transformative digital solutions that drive growth, efficiency, and innovation. We believe in creating technology that not only solves immediate challenges but also paves the way for future success.\n\nWe strive to be more than just a service provider – we aim to be strategic partners in our clients' digital transformation journeys, helping them navigate the complexities of modern technology with confidence and clarity.`,
// //       imageUrl: "/images/about-mission.jpg"
// //     }
// //   ],
// //   values: [
// //     {
// //       icon: <FaRocket />,
// //       title: "Innovation",
// //       description: "We constantly push boundaries and explore new technologies to deliver cutting-edge solutions that keep our clients ahead of the curve."
// //     },
// //     {
// //       icon: <FaShieldAlt />,
// //       title: "Excellence",
// //       description: "Quality is at the core of everything we do. We maintain the highest standards in our work and continuously strive for perfection."
// //     },
// //     {
// //       icon: <FaHandshake />,
// //       title: "Partnership",
// //       description: "We build lasting relationships with our clients, working collaboratively to understand their unique needs and deliver tailored solutions."
// //     },
// //     {
// //       icon: <FaLightbulb />,
// //       title: "Creativity",
// //       description: "Our team thinks outside the box to develop innovative approaches and creative solutions to complex business challenges."
// //     },
// //     {
// //       icon: <FaHeart />,
// //       title: "Passion",
// //       description: "We are passionate about technology and its potential to transform businesses and improve people's lives."
// //     },
// //     {
// //       icon: <FaUsers />,
// //       title: "Collaboration",
// //       description: "We believe in the power of teamwork and collaboration, both within our organization and with our clients and partners."
// //     }
// //   ],
// //   teamDescription: `Our team comprises passionate professionals, industry experts, and innovative thinkers who are dedicated to delivering exceptional results. With diverse backgrounds and specialized skills, we bring a wealth of experience to every project.\n\nWe foster a culture of continuous learning and growth, ensuring our team stays at the forefront of technological advancements. Our collaborative approach and commitment to excellence make us the ideal partner for your digital transformation journey.`
// // };

// // const About = () => {
// //     const [aboutContent, setAboutContent] = useState(null);
// //     const [loading, setLoading] = useState(true);
// //     const [error, setError] = useState(null);

// //     useEffect(() => {
// //         const fetchAboutContent = async () => {
// //             try {
// //                 // Try to fetch from API
// //                 const data = await getAboutContent();
// //                 setAboutContent(data);
// //             } catch (err) {
// //                 console.log('Using default content due to API error:', err);
// //                 // Use default content if API fails
// //                 setAboutContent(defaultAboutContent);
// //             } finally {
// //                 setLoading(false);
// //             }
// //         };

// //         fetchAboutContent();
// //     }, []);

// //     const containerVariants = {
// //         hidden: { opacity: 0 },
// //         visible: {
// //             opacity: 1,
// //             transition: {
// //                 staggerChildren: 0.2
// //             }
// //         }
// //     };

// //     const itemVariants = {
// //         hidden: { opacity: 0, y: 30 },
// //         visible: {
// //             opacity: 1,
// //             y: 0,
// //             transition: {
// //                 duration: 0.6,
// //                 ease: "easeOut"
// //             }
// //         }
// //     };

// //     if (loading) {
// //         return (
// //             <PageContainer>
// //                 <LoadingContainer>
// //                     <LoadingSpinner />
// //                     <LoadingMessage>Loading About Page...</LoadingMessage>
// //                 </LoadingContainer>
// //             </PageContainer>
// //         );
// //     }

// //     if (error && !aboutContent) {
// //         return (
// //             <PageContainer>
// //                 <ErrorMessage>
// //                     <h2>Oops! Something went wrong</h2>
// //                     <p>We're having trouble loading the content. Please try refreshing the page.</p>
// //                 </ErrorMessage>
// //             </PageContainer>
// //         );
// //     }

// //     const content = aboutContent || defaultAboutContent;

// //     return (
// //         <PageContainer>
// //             <HeroSection
// //                 variants={containerVariants}
// //                 initial="hidden"
// //                 animate="visible"
// //             >
// //                 <Title variants={itemVariants}>
// //                     {content.title}
// //                     <span>Driving Digital Excellence</span>
// //                 </Title>
// //                 <Subtitle variants={itemVariants}>
// //                     {content.subtitle}
// //                 </Subtitle>
// //             </HeroSection>

// //             <ContentSection
// //                 variants={containerVariants}
// //                 initial="hidden"
// //                 whileInView="visible"
// //                 viewport={{ once: true }}
// //             >
// //                 {content.sections.map((section, index) => (
// //                     <Section key={index} variants={itemVariants}>
// //                         <SectionTitle>{section.title}</SectionTitle>
// //                         <SectionContent reverse={index % 2 !== 0}>
// //                             <TextContent>
// //                                 {section.content.split('\n').map((paragraph, i) => (
// //                                     <p key={i}>{paragraph}</p>
// //                                 ))}
// //                             </TextContent>
// // <ImageContainer
// //     whileHover={{ scale: 1.02 }}
// //     transition={{ duration: 0.3 }}
// // >
// //     <img 
// //         src={companyFounder} 
// //         alt="Shiv Naresh - Founder of VVV IT Solutions"
// //     />
// // </ImageContainer>
// //                         </SectionContent>
// //                     </Section>
// //                 ))}

// //                 <Section variants={itemVariants}>
// //                     <SectionTitle>Our Values</SectionTitle>
// //                     <ValuesGrid>
// //                         {content.values.map((value, index) => (
// //                             <ValueCard
// //                                 key={index}
// //                                 variants={itemVariants}
// //                                 whileHover={{ y: -5 }}
// //                                 transition={{ delay: index * 0.1 }}
// //                             >
// //                                 <ValueIcon className="value-icon">
// //                                     {value.icon}
// //                                 </ValueIcon>
// //                                 <ValueTitle>{value.title}</ValueTitle>
// //                                 <ValueDescription>{value.description}</ValueDescription>
// //                             </ValueCard>
// //                         ))}
// //                     </ValuesGrid>
// //                 </Section>

// //                 <StatsSection variants={itemVariants}>
// //                     <SectionTitle style={{ color: 'white' }}>Our Impact</SectionTitle>
// //                     <StatsGrid>
// //                         <StatItem variants={itemVariants}>
// //                             <span className="stat-number">50+</span>
// //                             <div className="stat-label">Projects Completed</div>
// //                         </StatItem>
// //                         <StatItem variants={itemVariants}>
// //                             <span className="stat-number">15+</span>
// //                             <div className="stat-label">Products</div>
// //                         </StatItem>
// //                         <StatItem variants={itemVariants}>
// //                             <span className="stat-number">5+</span>
// //                             <div className="stat-label">Years Experience</div>
// //                         </StatItem>
// //                         <StatItem variants={itemVariants}>
// //                             <span className="stat-number">100%</span>
// //                             <div className="stat-label">Client Satisfaction</div>
// //                         </StatItem>
// //                     </StatsGrid>
// //                 </StatsSection>

// //                 <TeamSection variants={itemVariants}>
// //                     <SectionTitle>Our Team</SectionTitle>
// //                     <TeamContent>
// //                         <TextContent>
// //                             {content.teamDescription.split('\n').map((paragraph, i) => (
// //                                 <p key={i}>{paragraph}</p>
// //                             ))}
// //                         </TextContent>
// //                     </TeamContent>
// //                 </TeamSection>
// //             </ContentSection>
// //         </PageContainer>
// //     );
// // };

// // export default About;




// import React, { useState, useEffect } from 'react';
// import styled, { keyframes } from 'styled-components';
// import { motion, AnimatePresence } from 'framer-motion';
// import { 
//   FaUsers, FaRocket, FaHeart, FaShieldAlt, 
//   FaLightbulb, FaHandshake, FaAward, FaChartLine,
//   FaEnvelope, FaLinkedin, FaTwitter
// } from 'react-icons/fa';
// import { getAboutContent } from '../services/aboutService';
// import companyFounder from "../images/companyfounder.jpg";

// // Animations
// const fadeInUp = keyframes`
//   from {
//     opacity: 0;
//     transform: translateY(40px);
//   }
//   to {
//     opacity: 1;
//     transform: translateY(0);
//   }
// `;

// const gradientShift = keyframes`
//   0% {
//     background-position: 0% 50%;
//   }
//   50% {
//     background-position: 100% 50%;
//   }
//   100% {
//     background-position: 0% 50%;
//   }
// `;

// const float = keyframes`
//   0%, 100% {
//     transform: translateY(0px);
//   }
//   50% {
//     transform: translateY(-20px);
//   }
// `;

// // Styled Components
// const PageContainer = styled.div`
//   padding: 120px 20px 80px;
//   max-width: 1400px;
//   margin: 0 auto;
//   min-height: 100vh;
//   background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
//   position: relative;
  
//   &::before {
//     content: '';
//     position: absolute;
//     top: 0;
//     left: 0;
//     right: 0;
//     height: 1px;
//     background: linear-gradient(90deg, transparent, #e2e8f0, transparent);
//   }
// `;

// const HeroSection = styled(motion.section)`
//   text-align: center;
//   margin-bottom: 80px;
//   padding: 80px 40px;
//   background: linear-gradient(135deg, #0A2342 0%, #005f56 50%, #0A2342 100%);
//   border-radius: 24px;
//   color: #FFFFFF;
//   position: relative;
//   overflow: hidden;
//   box-shadow: 0 20px 40px rgba(10, 35, 66, 0.3);

//   &::before {
//     content: '';
//     position: absolute;
//     top: 0;
//     left: 0;
//     right: 0;
//     bottom: 0;
//     background: 
//       radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.1) 0%, transparent 50%),
//       radial-gradient(circle at 80% 20%, rgba(255, 200, 87, 0.1) 0%, transparent 50%);
//     background-blend-mode: overlay;
//   }

//   @media (max-width: 768px) {
//     padding: 60px 20px;
//     margin-bottom: 60px;
//   }
// `;

// const Title = styled.h1`
//   font-size: clamp(2.5rem, 5vw, 4rem);
//   font-weight: 800;
//   margin-bottom: 20px;
//   letter-spacing: -0.02em;
//   position: relative;
//   z-index: 2;
  
//   span {
//     display: block;
//     font-size: clamp(1rem, 2vw, 1.5rem);
//     color: #FFC857;
//     margin-top: 1rem;
//     font-weight: 600;
//     letter-spacing: 0.3em;
//     text-transform: uppercase;
//     background: linear-gradient(135deg, #FFC857, #FF9F1C);
//     -webkit-background-clip: text;
//     -webkit-text-fill-color: transparent;
//     background-clip: text;
//   }
// `;

// const Subtitle = styled.p`
//   font-size: clamp(1.1rem, 2vw, 1.4rem);
//   color: rgba(244, 244, 244, 0.95);
//   max-width: 700px;
//   margin: 0 auto;
//   line-height: 1.6;
//   font-weight: 300;
//   position: relative;
//   z-index: 2;
// `;
// const ImageContainer = styled(motion.div)`
//   position: relative;
//   overflow: hidden;
//   border-radius: 16px;
//   box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
//   background: #ffffff;
//   max-width: 300px; /* smaller, more compact */
//   margin: 0 auto;
//   padding: 8px; /* adds a small border spacing */

//   img {
//     width: 100%;
//     height: auto;
//     display: block;
//     border-radius: 12px;
//     transition: transform 0.3s ease;
//   }

//   &:hover img {
//     transform: scale(1.02);
//   }

//   @media (max-width: 768px) {
//     max-width: 220px; /* compact on mobile */
//   }
// `;


// const FounderInfo = styled(motion.div)`
//   background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
//   padding: 30px;
//   border-radius: 15px;
//   box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
//   border-left: 4px solid #00A896;
//   margin-top: 20px;

//   h3 {
//     color: #0A2342;
//     font-size: 1.4rem;
//     margin-bottom: 15px;
//     font-weight: 700;
//   }

//   p {
//     color: #475569;
//     line-height: 1.6;
//     margin-bottom: 15px;
//     font-size: 1rem;
//   }

//   .founder-role {
//     color: #00A896;
//     font-weight: 600;
//     font-size: 1.1rem;
//     margin-bottom: 10px;
//   }

//   .contact-info {
//     display: flex;
//     align-items: center;
//     gap: 10px;
//     margin: 10px 0;
//     color: #64748b;
//     font-size: 0.95rem;

//     svg {
//       color: #00A896;
//       font-size: 1.1rem;
//     }

//     a {
//       color: #0A2342;
//       text-decoration: none;
//       transition: color 0.3s ease;

//       &:hover {
//         color: #00A896;
//       }
//     }
//   }

//   @media (max-width: 768px) {
//     padding: 20px;
    
//     h3 {
//       font-size: 1.2rem;
//     }
    
//     p {
//       font-size: 0.9rem;
//     }
//   }
// `;

// const ContentSection = styled(motion.section)`
//   margin-top: 40px;
// `;

// const Section = styled(motion.div)`
//   margin-bottom: 100px;
//   padding: 0 20px;

//   @media (max-width: 768px) {
//     margin-bottom: 80px;
//   }
// `;

// const SectionTitle = styled.h2`
//   font-size: clamp(2rem, 4vw, 3rem);
//   color: #0A2342;
//   margin-bottom: 50px;
//   text-align: center;
//   position: relative;
//   font-weight: 800;
//   letter-spacing: -0.02em;
  
//   &::after {
//     content: '';
//     position: absolute;
//     bottom: -20px;
//     left: 50%;
//     transform: translateX(-50%);
//     width: 80px;
//     height: 4px;
//     background: linear-gradient(to right, #0A2342, #00A896);
//     border-radius: 2px;
//   }
// `;

// const SectionContent = styled.div`
//   display: grid;
//   grid-template-columns: ${props => props.reverse ? '1fr 1.2fr' : '1.2fr 1fr'};
//   gap: 60px;
//   align-items: start;
//   max-width: 1200px;
//   margin: 0 auto;

//   @media (max-width: 1024px) {
//     gap: 40px;
//   }

//   @media (max-width: 768px) {
//     grid-template-columns: 1fr;
//     gap: 40px;
//   }
// `;

// const TextContent = styled.div`
//   color: #475569;
//   line-height: 1.8;
//   font-size: 1.15rem;
//   font-weight: 400;

//   p {
//     margin-bottom: 1.5rem;
    
//     &:last-child {
//       margin-bottom: 0;
//     }
//   }

//   strong {
//     color: #0A2342;
//     font-weight: 700;
//   }

//   em {
//     color: #00A896;
//     font-style: normal;
//     font-weight: 600;
//   }
// `;

// const ValuesGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
//   gap: 40px;
//   margin-top: 50px;
//   max-width: 1200px;
//   margin: 50px auto 0;

//   @media (max-width: 768px) {
//     grid-template-columns: 1fr;
//     gap: 30px;
//   }
// `;

// const ValueCard = styled(motion.div)`
//   background: #ffffff;
//   padding: 50px 40px;
//   border-radius: 20px;
//   text-align: center;
//   box-shadow: 
//     0 10px 30px rgba(0, 0, 0, 0.08),
//     0 0 0 1px rgba(0, 0, 0, 0.03);
//   border-top: 4px solid #00A896;
//   transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
//   position: relative;
//   overflow: hidden;

//   &::before {
//     content: '';
//     position: absolute;
//     top: 0;
//     left: -100%;
//     width: 100%;
//     height: 100%;
//     background: linear-gradient(90deg, transparent, rgba(0, 168, 150, 0.05), transparent);
//     transition: left 0.6s ease;
//   }

//   &:hover {
//     transform: translateY(-8px);
//     box-shadow: 
//       0 25px 50px -12px rgba(0, 0, 0, 0.15),
//       0 0 0 1px rgba(0, 0, 0, 0.03);

//     &::before {
//       left: 100%;
//     }

//     .value-icon {
//       transform: scale(1.1) rotate(5deg);
//       color: #00A896;
//       animation: ${float} 3s ease-in-out infinite;
//     }
//   }
// `;

// const ValueIcon = styled.div`
//   font-size: 3.5rem;
//   color: #0A2342;
//   margin-bottom: 25px;
//   transition: all 0.4s ease;
// `;

// const ValueTitle = styled.h3`
//   color: #0A2342;
//   margin-bottom: 20px;
//   font-size: 1.5rem;
//   font-weight: 700;
// `;

// const ValueDescription = styled.p`
//   color: #64748b;
//   line-height: 1.7;
//   font-size: 1.05rem;
//   font-weight: 400;
// `;

// const StatsSection = styled(Section)`
//   background: linear-gradient(135deg, #0A2342 0%, #005f56 100%);
//   color: white;
//   padding: 80px 40px;
//   border-radius: 24px;
//   margin: 100px auto;
//   max-width: 1200px;
//   text-align: center;
//   position: relative;
//   overflow: hidden;

//   &::before {
//     content: '';
//     position: absolute;
//     top: 0;
//     left: 0;
//     right: 0;
//     bottom: 0;
//     background: url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Cpath d='m0 40l40-40h-40v40zm40 0v-40h-40l40 40z'/%3E%3C/g%3E%3C/svg%3E");
//   }

//   @media (max-width: 768px) {
//     padding: 60px 20px;
//     margin: 80px auto;
//   }
// `;

// const StatsGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
//   gap: 50px;
//   margin-top: 50px;
//   position: relative;
//   z-index: 2;

//   @media (max-width: 768px) {
//     grid-template-columns: repeat(2, 1fr);
//     gap: 40px;
//   }
// `;

// const StatItem = styled(motion.div)`
//   text-align: center;
  
//   .stat-number {
//     font-size: 3.5rem;
//     font-weight: 800;
//     color: #FFC857;
//     margin-bottom: 10px;
//     display: block;
//     line-height: 1;
//   }
  
//   .stat-label {
//     font-size: 1.2rem;
//     color: rgba(255, 255, 255, 0.9);
//     font-weight: 500;
//   }
// `;

// const TeamSection = styled(Section)`
//   text-align: center;
// `;

// const TeamContent = styled.div`
//   max-width: 800px;
//   margin: 0 auto;
// `;

// const LoadingContainer = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   min-height: 60vh;
//   flex-direction: column;
//   gap: 20px;
// `;

// const LoadingSpinner = styled.div`
//   width: 50px;
//   height: 50px;
//   border: 4px solid #f3f3f3;
//   border-top: 4px solid #00A896;
//   border-radius: 50%;
//   animation: spin 1s linear infinite;

//   @keyframes spin {
//     0% { transform: rotate(0deg); }
//     100% { transform: rotate(360deg); }
//   }
// `;

// const LoadingMessage = styled.div`
//   text-align: center;
//   color: #64748b;
//   font-size: 1.2rem;
//   font-weight: 500;
// `;

// const ErrorMessage = styled.div`
//   text-align: center;
//   padding: 60px 40px;
//   background: #ffffff;
//   border-radius: 20px;
//   box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
//   max-width: 600px;
//   margin: 100px auto;

//   h2 {
//     color: #dc3545;
//     margin-bottom: 20px;
//     font-size: 1.8rem;
//     font-weight: 700;
//   }

//   p {
//     color: #64748b;
//     font-size: 1.1rem;
//     line-height: 1.6;
//   }
// `;

// // Default content in case API fails
// const defaultAboutContent = {
//   title: "About VVV IT Solutions",
//   subtitle: "Pioneering digital transformation through innovative technology solutions",
//   sections: [
//     {
//       title: "Our Story",
//       content: `Founded with a vision to revolutionize the digital landscape, VVV IT Solutions has emerged as a trusted partner for businesses seeking cutting-edge technology solutions. Our journey began with a simple yet powerful mission: to bridge the gap between complex business challenges and innovative technological solutions.\n\nOver the years, we've grown from a small startup to a comprehensive IT solutions provider, serving clients across various industries. Our commitment to excellence and customer satisfaction has been the driving force behind our success.`,
//       imageUrl: "/images/about-story.jpg"
//     },
//     {
//       title: "Our Mission",
//       content: `At VVV IT Solutions, our mission is to empower businesses with transformative digital solutions that drive growth, efficiency, and innovation. We believe in creating technology that not only solves immediate challenges but also paves the way for future success.\n\nWe strive to be more than just a service provider – we aim to be strategic partners in our clients' digital transformation journeys, helping them navigate the complexities of modern technology with confidence and clarity.`,
//       // imageUrl: "/images/about-mission.jpg"
//     }
//   ],
//   values: [
//     {
//       icon: <FaRocket />,
//       title: "Innovation",
//       description: "We constantly push boundaries and explore new technologies to deliver cutting-edge solutions that keep our clients ahead of the curve."
//     },
//     {
//       icon: <FaShieldAlt />,
//       title: "Excellence",
//       description: "Quality is at the core of everything we do. We maintain the highest standards in our work and continuously strive for perfection."
//     },
//     {
//       icon: <FaHandshake />,
//       title: "Partnership",
//       description: "We build lasting relationships with our clients, working collaboratively to understand their unique needs and deliver tailored solutions."
//     },
//     {
//       icon: <FaLightbulb />,
//       title: "Creativity",
//       description: "Our team thinks outside the box to develop innovative approaches and creative solutions to complex business challenges."
//     },
//     {
//       icon: <FaHeart />,
//       title: "Passion",
//       description: "We are passionate about technology and its potential to transform businesses and improve people's lives."
//     },
//     {
//       icon: <FaUsers />,
//       title: "Collaboration",
//       description: "We believe in the power of teamwork and collaboration, both within our organization and with our clients and partners."
//     }
//   ],
//   teamDescription: `Our team comprises passionate professionals, industry experts, and innovative thinkers who are dedicated to delivering exceptional results. With diverse backgrounds and specialized skills, we bring a wealth of experience to every project.\n\nWe foster a culture of continuous learning and growth, ensuring our team stays at the forefront of technological advancements. Our collaborative approach and commitment to excellence make us the ideal partner for your digital transformation journey.`
// };

// const About = () => {
//     const [aboutContent, setAboutContent] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);

//     useEffect(() => {
//         const fetchAboutContent = async () => {
//             try {
//                 // Try to fetch from API
//                 const data = await getAboutContent();
//                 setAboutContent(data);
//             } catch (err) {
//                 console.log('Using default content due to API error:', err);
//                 // Use default content if API fails
//                 setAboutContent(defaultAboutContent);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchAboutContent();
//     }, []);

//     const containerVariants = {
//         hidden: { opacity: 0 },
//         visible: {
//             opacity: 1,
//             transition: {
//                 staggerChildren: 0.2
//             }
//         }
//     };

//     const itemVariants = {
//         hidden: { opacity: 0, y: 30 },
//         visible: {
//             opacity: 1,
//             y: 0,
//             transition: {
//                 duration: 0.6,
//                 ease: "easeOut"
//             }
//         }
//     };

//     if (loading) {
//         return (
//             <PageContainer>
//                 <LoadingContainer>
//                     <LoadingSpinner />
//                     <LoadingMessage>Loading About Page...</LoadingMessage>
//                 </LoadingContainer>
//             </PageContainer>
//         );
//     }

//     if (error && !aboutContent) {
//         return (
//             <PageContainer>
//                 <ErrorMessage>
//                     <h2>Oops! Something went wrong</h2>
//                     <p>We're having trouble loading the content. Please try refreshing the page.</p>
//                 </ErrorMessage>
//             </PageContainer>
//         );
//     }

//     const content = aboutContent || defaultAboutContent;

//     return (
//         <PageContainer>
//             <HeroSection
//                 variants={containerVariants}
//                 initial="hidden"
//                 animate="visible"
//             >
//                 <Title variants={itemVariants}>
//                     {content.title}
//                     <span>Driving Digital Excellence</span>
//                 </Title>
//                 <Subtitle variants={itemVariants}>
//                     {content.subtitle}
//                 </Subtitle>
//             </HeroSection>

//             <ContentSection
//                 variants={containerVariants}
//                 initial="hidden"
//                 whileInView="visible"
//                 viewport={{ once: true }}
//             >
//                 {/* Our Story Section with Founder Image */}
//                 <Section variants={itemVariants}>
//                     <SectionTitle>Our Story</SectionTitle>
//                     <SectionContent reverse={false}>
//                         <TextContent>
//                             <p>
//                                 Founded with a vision to revolutionize the digital landscape, <strong>VVV IT Solutions</strong> has emerged as a trusted partner for businesses seeking cutting-edge technology solutions. Our journey began with a simple yet powerful mission: to bridge the gap between complex business challenges and innovative technological solutions.
//                             </p>
//                             <p>
//                                 Over the years, we've grown from a small startup to a comprehensive IT solutions provider, serving clients across various industries. Our commitment to excellence and customer satisfaction has been the driving force behind our success.
//                             </p>
//                             <p>
//                                 Under the leadership of our founder <strong>Shiv Naresh</strong>, we have successfully delivered numerous government and enterprise projects, establishing ourselves as a reliable technology partner in the digital transformation space.
//                             </p>
//                         </TextContent>
//                         <div>
//                             <ImageContainer
//                                 whileHover={{ scale: 1.02 }}
//                                 transition={{ duration: 0.3 }}
//                             >
//                                 <img 
//                                     src={companyFounder} 
//                                     alt="Shiv Naresh - Founder & CEO of VVV IT Solutions"
//                                 />
//                             </ImageContainer>
//                             <FounderInfo variants={itemVariants}>
//                                 <h3>Shiv Naresh</h3>
//                                 <p className="founder-role">Founder & CEO</p>
//                                 <p>
//                                     Visionary leader and technology enthusiast with over 8 years of experience 
//                                     in software development and digital transformation. Shiv Naresh founded 
//                                     VVV IT Solutions with a mission to create impactful digital solutions.
//                                 </p>
//                                 <div className="contact-info">
//                                     <FaEnvelope />
//                                     <a href="mailto:shiv.naresh@vvvitsolutions.com">
//                                         shiv.naresh@vvvitsolutions.com
//                                     </a>
//                                 </div>
//                                 <div className="contact-info">
//                                     <FaLinkedin />
//                                     <a href="https://linkedin.com/in/shivnaresh" target="_blank" rel="noopener noreferrer">
//                                         Connect on LinkedIn
//                                     </a>
//                                 </div>
//                             </FounderInfo>
//                         </div>
//                     </SectionContent>
//                 </Section>

//                 {/* Our Mission Section - No Image */}
//                 <Section variants={itemVariants}>
//                     <SectionTitle>Our Mission</SectionTitle>
//                     <SectionContent reverse={true}>
//                         <TextContent>
//                             <p>
//                                 At <strong>VVV IT Solutions</strong>, our mission is to empower businesses with transformative digital solutions that drive growth, efficiency, and innovation. We believe in creating technology that not only solves immediate challenges but also paves the way for future success.
//                             </p>
//                             <p>
//                                 We strive to be more than just a service provider – we aim to be <em>strategic partners</em> in our clients' digital transformation journeys, helping them navigate the complexities of modern technology with confidence and clarity.
//                             </p>
//                             <p>
//                                 Our commitment extends beyond delivering code; we focus on understanding our clients' unique needs and providing solutions that create lasting value and competitive advantage in today's digital landscape.
//                             </p>
//                         </TextContent>
//                         <TextContent>
//                             <p>
//                                 We are dedicated to:
//                             </p>
//                             <ul style={{ color: '#475569', lineHeight: '1.8', fontSize: '1.15rem' }}>
//                                 <li>Delivering <strong>high-quality, scalable solutions</strong> that grow with your business</li>
//                                 <li>Providing <strong>expert guidance</strong> and technical expertise at every step</li>
//                                 <li>Ensuring <strong>timely delivery</strong> without compromising on quality</li>
//                                 <li>Building <strong>long-term partnerships</strong> based on trust and results</li>
//                                 <li>Staying at the <strong>forefront of technology</strong> to offer cutting-edge solutions</li>
//                             </ul>
//                         </TextContent>
//                     </SectionContent>
//                 </Section>

//                 <Section variants={itemVariants}>
//                     <SectionTitle>Our Values</SectionTitle>
//                     <ValuesGrid>
//                         {content.values.map((value, index) => (
//                             <ValueCard
//                                 key={index}
//                                 variants={itemVariants}
//                                 whileHover={{ y: -5 }}
//                                 transition={{ delay: index * 0.1 }}
//                             >
//                                 <ValueIcon className="value-icon">
//                                     {value.icon}
//                                 </ValueIcon>
//                                 <ValueTitle>{value.title}</ValueTitle>
//                                 <ValueDescription>{value.description}</ValueDescription>
//                             </ValueCard>
//                         ))}
//                     </ValuesGrid>
//                 </Section>

//                 <StatsSection variants={itemVariants}>
//                     <SectionTitle style={{ color: 'white' }}>Our Impact</SectionTitle>
//                     <StatsGrid>
//                         <StatItem variants={itemVariants}>
//                             <span className="stat-number">50+</span>
//                             <div className="stat-label">Projects Completed</div>
//                         </StatItem>
//                         <StatItem variants={itemVariants}>
//                             <span className="stat-number">15+</span>
//                             <div className="stat-label">Products</div>
//                         </StatItem>
//                         <StatItem variants={itemVariants}>
//                             <span className="stat-number">5+</span>
//                             <div className="stat-label">Years Experience</div>
//                         </StatItem>
//                         <StatItem variants={itemVariants}>
//                             <span className="stat-number">100%</span>
//                             <div className="stat-label">Client Satisfaction</div>
//                         </StatItem>
//                     </StatsGrid>
//                 </StatsSection>

//                 <TeamSection variants={itemVariants}>
//                     <SectionTitle>Our Team</SectionTitle>
//                     <TeamContent>
//                         <TextContent>
//                             {content.teamDescription.split('\n').map((paragraph, i) => (
//                                 <p key={i}>{paragraph}</p>
//                             ))}
//                         </TextContent>
//                     </TeamContent>
//                 </TeamSection>
//             </ContentSection>
//         </PageContainer>
//     );
// };

// export default About;



import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  FaUsers, FaRocket, FaHeart, FaShieldAlt, 
  FaLightbulb, FaHandshake, FaAward, FaChartLine,
  FaEnvelope, FaLinkedin, FaStar, FaCheck
} from 'react-icons/fa';
import { getAboutContent } from '../services/aboutService';
import companyFounder from "../images/companyfounder.png";

// Premium Animations
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const float = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
`;

const shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

const gradientShift = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

// Premium Styled Components
const PageContainer = styled.div`
  padding: 120px 20px 80px;
  max-width: 1400px;
  margin: 0 auto;
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 50%, #ffffff 100%);
  position: relative;
  overflow-x: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, #e2e8f0, transparent);
  }

  @media (max-width: 768px) {
    padding: 100px 15px 60px;
  }
`;

const HeroSection = styled(motion.section)`
  text-align: center;
  margin-bottom: 100px;
  padding: 100px 40px;
  background: linear-gradient(135deg, var(--theme-hero-start) 0%, var(--theme-hero-end) 50%, var(--theme-hero-start) 100%);
  background-size: 200% 200%;
  animation: ${gradientShift} 8s ease infinite;
  border-radius: 32px;
  color: #FFFFFF;
  position: relative;
  overflow: hidden;
  box-shadow: 
    0 25px 50px -12px var(--theme-shadow-accent),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
      radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.15) 0%, transparent 50%),
      radial-gradient(circle at 80% 20%, rgba(255, 200, 87, 0.1) 0%, transparent 50%),
      linear-gradient(135deg, transparent 0%, rgba(255, 255, 255, 0.05) 100%);
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
    animation: ${shimmer} 3s infinite;
  }

  @media (max-width: 768px) {
    padding: 80px 20px;
    margin-bottom: 80px;
    border-radius: 24px;
  }

  @media (max-width: 480px) {
    padding: 60px 15px;
    margin-bottom: 60px;
  }
`;

const Title = styled.h1`
  font-size: clamp(2.8rem, 6vw, 4.5rem);
  font-weight: 800;
  margin-bottom: 24px;
  letter-spacing: -0.02em;
  position: relative;
  z-index: 2;
  line-height: 1.1;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  
  span {
    display: block;
    font-size: clamp(1.1rem, 2.5vw, 1.6rem);
    color: #FFC857;
    margin-top: 1.5rem;
    font-weight: 600;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    background: linear-gradient(135deg, #FFC857, #FF9F1C, #FFC857);
    background-size: 200% 200%;
    animation: ${gradientShift} 3s ease infinite;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  @media (max-width: 768px) {
    margin-bottom: 20px;
  }
`;

const Subtitle = styled.p`
  font-size: clamp(1.2rem, 2.5vw, 1.5rem);
  color: rgba(244, 244, 244, 0.95);
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6;
  font-weight: 300;
  position: relative;
  z-index: 2;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);

  @media (max-width: 768px) {
    font-size: clamp(1.1rem, 3vw, 1.3rem);
  }
`;

const ContentSection = styled(motion.section)`
  margin-top: 40px;
`;

const Section = styled(motion.div)`
  margin-bottom: 120px;
  padding: 0 20px;

  @media (max-width: 768px) {
    margin-bottom: 80px;
    padding: 0 15px;
  }

  @media (max-width: 480px) {
    margin-bottom: 60px;
    padding: 0 10px;
  }
`;

const SectionTitle = styled.h2`
  font-size: clamp(2.2rem, 5vw, 3.2rem);
  color: var(--theme-primary);
  margin-bottom: 60px;
  text-align: center;
  position: relative;
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.2;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -25px;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    height: 5px;
    background: linear-gradient(to right, var(--theme-primary), var(--theme-accent), var(--theme-primary));
    border-radius: 3px;
    background-size: 200% 100%;
    animation: ${gradientShift} 3s ease infinite;
  }

  @media (max-width: 768px) {
    margin-bottom: 50px;
    
    &::after {
      bottom: -20px;
      width: 80px;
    }
  }
`;

const SectionContent = styled.div`
  display: grid;
  grid-template-columns: ${props => props.reverse ? '1fr 1.1fr' : '1.1fr 1fr'};
  gap: 80px;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 1024px) {
    gap: 60px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 50px;
  }

  @media (max-width: 480px) {
    gap: 40px;
  }
`;

const TextContent = styled.div`
  color: #475569;
  line-height: 1.8;
  font-size: 1.15rem;
  font-weight: 400;

  p {
    margin-bottom: 1.8rem;
    position: relative;
    
    &:last-child {
      margin-bottom: 0;
    }
  }

  strong {
    color: var(--theme-primary);
    font-weight: 700;
    background: linear-gradient(135deg, var(--theme-hero-start), var(--theme-hero-end));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  em {
    color: var(--theme-accent);
    font-style: normal;
    font-weight: 600;
  }

  @media (max-width: 768px) {
    font-size: 1.1rem;
    line-height: 1.7;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
    line-height: 1.6;
  }
`;
const ImageContainer = styled(motion.div)`
  position: relative;
  overflow: hidden;
  border-radius: 50%; /* makes it circular */
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  background: #ffffff;
  max-width: 320px; /* adjusted for balanced circular view */
  margin: 0 auto;
  padding: 8px;
  aspect-ratio: 1 / 1; /* ensures perfect circle */

  img {
    width: 100%;
    height: 100%;
    object-fit: cover; /* maintains image proportions */
    border-radius: 50%; /* ensures image fits circular shape */
    transition: transform 0.3s ease;
  }

  &:hover img {
    transform: scale(1.05);
  }

  @media (max-width: 1024px) {
    max-width: 280px;
  }

  @media (max-width: 768px) {
    max-width: 220px;
  }

  @media (max-width: 480px) {
    max-width: 180px;
  }
`;




const FounderInfo = styled(motion.div)`
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  padding: 40px 35px;
  border-radius: 20px;
  box-shadow: 
    0 15px 35px rgba(0, 0, 0, 0.08),
    0 5px 15px var(--theme-accent-soft),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  border-left: 5px solid var(--theme-accent);
  margin-top: 30px;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(to right, var(--theme-accent), var(--theme-primary), var(--theme-accent));
    background-size: 200% 100%;
    animation: ${gradientShift} 3s ease infinite;
  }

  h3 {
    color: var(--theme-primary);
    font-size: 1.5rem;
    margin-bottom: 12px;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .founder-role {
    color: var(--theme-accent);
    font-weight: 600;
    font-size: 1.1rem;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  p {
    color: #475569;
    line-height: 1.7;
    margin-bottom: 20px;
    font-size: 1rem;
    position: relative;
    padding-left: 15px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 8px;
      width: 6px;
      height: 6px;
      background: var(--theme-accent);
      border-radius: 50%;
    }
  }

  .contact-info {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 15px 0;
    color: #64748b;
    font-size: 0.95rem;
    padding: 8px 0;
    transition: all 0.3s ease;

    &:hover {
      transform: translateX(5px);
    }

    svg {
      color: var(--theme-accent);
      font-size: 1.1rem;
      flex-shrink: 0;
    }

    a {
      color: var(--theme-primary);
      text-decoration: none;
      transition: color 0.3s ease;
      font-weight: 500;

      &:hover {
        color: var(--theme-accent);
      }
    }
  }

  @media (max-width: 768px) {
    padding: 30px 25px;
    
    h3 {
      font-size: 1.3rem;
    }
    
    p {
      font-size: 0.95rem;
    }
  }

  @media (max-width: 480px) {
    padding: 25px 20px;
    margin-top: 25px;
  }
`;

const MissionList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 25px 0;

  li {
    color: #475569;
    line-height: 1.7;
    margin-bottom: 16px;
    font-size: 1.1rem;
    display: flex;
    align-items: flex-start;
    gap: 15px;
    padding: 12px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);

    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
    }

    svg {
      color: var(--theme-accent);
      font-size: 1.1rem;
      margin-top: 3px;
      flex-shrink: 0;
      background: var(--theme-accent-soft);
      padding: 6px;
      border-radius: 50%;
    }

    strong {
      color: var(--theme-primary);
      font-weight: 600;
      background: linear-gradient(135deg, var(--theme-hero-start), var(--theme-hero-end));
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
  }

  @media (max-width: 768px) {
    li {
      font-size: 1rem;
      gap: 12px;
    }
  }
`;

const ValuesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 50px;
  margin-top: 60px;
  max-width: 1300px;
  margin: 60px auto 0;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 40px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 30px;
    margin-top: 50px;
  }

  @media (max-width: 480px) {
    gap: 25px;
  }
`;

const ValueCard = styled(motion.div)`
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  padding: 50px 40px;
  border-radius: 24px;
  text-align: center;
  box-shadow: 
    0 15px 35px rgba(0, 0, 0, 0.08),
    0 5px 15px var(--theme-accent-soft),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  border-top: 4px solid var(--theme-accent);
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, var(--theme-accent-soft), transparent);
    transition: left 0.6s ease;
  }

  &:hover {
    transform: translateY(-10px) scale(1.02);
    box-shadow: 
      0 25px 50px -12px rgba(0, 0, 0, 0.15),
      0 10px 25px var(--theme-shadow-accent);

    &::before {
      left: 100%;
    }

    .value-icon {
      transform: scale(1.1);
      color: var(--theme-accent);
      animation: ${float} 2s ease-in-out infinite;
    }
  }

  @media (max-width: 768px) {
    padding: 40px 30px;
  }

  @media (max-width: 480px) {
    padding: 35px 25px;
  }
`;

const ValueIcon = styled.div`
  font-size: 3.5rem;
  color: var(--theme-primary);
  margin-bottom: 30px;
  transition: all 0.5s ease;
  display: inline-block;

  @media (max-width: 768px) {
    font-size: 3rem;
    margin-bottom: 25px;
  }
`;

const ValueTitle = styled.h3`
  color: var(--theme-primary);
  margin-bottom: 20px;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 1.3rem;
  }
`;

const ValueDescription = styled.p`
  color: #64748b;
  line-height: 1.7;
  font-size: 1.05rem;
  font-weight: 400;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const StatsSection = styled(Section)`
  background: linear-gradient(135deg, var(--theme-hero-start) 0%, var(--theme-hero-end) 100%);
  background-size: 200% 200%;
  animation: ${gradientShift} 8s ease infinite;
  color: white;
  padding: 100px 40px;
  border-radius: 32px;
  margin: 120px auto;
  max-width: 1200px;
  text-align: center;
  position: relative;
  overflow: hidden;
  box-shadow: 
    0 25px 50px -12px var(--theme-shadow-accent),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Cpath d='m0 60l60-60h-60v60zm60 0v-60h-60l60 60z'/%3E%3C/g%3E%3C/svg%3E");
  }

  @media (max-width: 768px) {
    padding: 80px 20px;
    margin: 100px auto;
    border-radius: 24px;
  }

  @media (max-width: 480px) {
    padding: 60px 15px;
    margin: 80px auto;
  }
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 60px;
  margin-top: 60px;
  position: relative;
  z-index: 2;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 50px;
    margin-top: 50px;
  }

  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 40px;
  }
`;

const StatItem = styled(motion.div)`
  text-align: center;
  
  .stat-number {
    font-size: 3.5rem;
    font-weight: 800;
    color: #FFC857;
    margin-bottom: 15px;
    display: block;
    line-height: 1;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  }
  
  .stat-label {
    font-size: 1.2rem;
    color: rgba(255, 255, 255, 0.9);
    font-weight: 500;
    line-height: 1.4;
  }

  @media (max-width: 768px) {
    .stat-number {
      font-size: 3rem;
    }
    
    .stat-label {
      font-size: 1.1rem;
    }
  }

  @media (max-width: 480px) {
    .stat-number {
      font-size: 2.5rem;
    }
    
    .stat-label {
      font-size: 1rem;
    }
  }
`;

const TeamSection = styled(Section)`
  text-align: center;
`;

const TeamContent = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  flex-direction: column;
  gap: 25px;
`;

const LoadingSpinner = styled.div`
  width: 60px;
  height: 60px;
  border: 4px solid var(--theme-accent-soft);
  border-top: 4px solid var(--theme-accent);
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const LoadingMessage = styled.div`
  text-align: center;
  color: #64748b;
  font-size: 1.3rem;
  font-weight: 500;
`;

const ErrorMessage = styled.div`
  text-align: center;
  padding: 80px 40px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 24px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.08);
  max-width: 600px;
  margin: 100px auto;
  border-left: 5px solid #dc3545;

  h2 {
    color: #dc3545;
    margin-bottom: 20px;
    font-size: 2rem;
    font-weight: 700;
  }

  p {
    color: #64748b;
    font-size: 1.2rem;
    line-height: 1.6;
  }

  @media (max-width: 768px) {
    padding: 60px 30px;
    
    h2 {
      font-size: 1.8rem;
    }
    
    p {
      font-size: 1.1rem;
    }
  }
`;

// Default content in case API fails
const defaultAboutContent = {
  title: "About VVV IT Solutions",
  subtitle: "Pioneering digital transformation through innovative technology solutions",
  sections: [
    {
      title: "Our Story",
      content: `Founded with a vision to revolutionize the digital landscape, VVV IT Solutions has emerged as a trusted partner for businesses seeking cutting-edge technology solutions. Our journey began with a simple yet powerful mission: to bridge the gap between complex business challenges and innovative technological solutions.\n\nOver the years, we've grown from a small startup to a comprehensive IT solutions provider, serving clients across various industries. Our commitment to excellence and customer satisfaction has been the driving force behind our success.`,
    },
    {
      title: "Our Mission",
      content: `At VVV IT Solutions, our mission is to empower businesses with transformative digital solutions that drive growth, efficiency, and innovation. We believe in creating technology that not only solves immediate challenges but also paves the way for future success.\n\nWe strive to be more than just a service provider – we aim to be strategic partners in our clients' digital transformation journeys, helping them navigate the complexities of modern technology with confidence and clarity.`,
    }
  ],
  values: [
    {
      icon: <FaRocket />,
      title: "Innovation",
      description: "We constantly push boundaries and explore new technologies to deliver cutting-edge solutions that keep our clients ahead of the curve."
    },
    {
      icon: <FaShieldAlt />,
      title: "Excellence",
      description: "Quality is at the core of everything we do. We maintain the highest standards in our work and continuously strive for perfection."
    },
    {
      icon: <FaHandshake />,
      title: "Partnership",
      description: "We build lasting relationships with our clients, working collaboratively to understand their unique needs and deliver tailored solutions."
    },
    {
      icon: <FaLightbulb />,
      title: "Creativity",
      description: "Our team thinks outside the box to develop innovative approaches and creative solutions to complex business challenges."
    },
    {
      icon: <FaHeart />,
      title: "Passion",
      description: "We are passionate about technology and its potential to transform businesses and improve people's lives."
    },
    {
      icon: <FaUsers />,
      title: "Collaboration",
      description: "We believe in the power of teamwork and collaboration, both within our organization and with our clients and partners."
    }
  ],
  teamDescription: `Our team comprises passionate professionals, industry experts, and innovative thinkers who are dedicated to delivering exceptional results. With diverse backgrounds and specialized skills, we bring a wealth of experience to every project.\n\nWe foster a culture of continuous learning and growth, ensuring our team stays at the forefront of technological advancements. Our collaborative approach and commitment to excellence make us the ideal partner for your digital transformation journey.`
};

const About = () => {
    const [aboutContent, setAboutContent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchAboutContent = async () => {
            try {
                const data = await getAboutContent();
                setAboutContent(data);
            } catch (err) {
                console.log('Using default content due to API error:', err);
                setAboutContent(defaultAboutContent);
            } finally {
                setLoading(false);
            }
        };

        fetchAboutContent();
    }, []);

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                ease: "easeOut"
            }
        }
    };

    if (loading) {
        return (
            <PageContainer>
                <LoadingContainer>
                    <LoadingSpinner />
                    <LoadingMessage>Loading About Page...</LoadingMessage>
                </LoadingContainer>
            </PageContainer>
        );
    }

    if (error && !aboutContent) {
        return (
            <PageContainer>
                <ErrorMessage>
                    <h2>Oops! Something went wrong</h2>
                    <p>We're having trouble loading the content. Please try refreshing the page.</p>
                </ErrorMessage>
            </PageContainer>
        );
    }

    const content = aboutContent || defaultAboutContent;

    return (
        <PageContainer>
            <HeroSection
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                <Title variants={itemVariants}>
                    {content.title}
                    <span>Driving Digital Excellence</span>
                </Title>
                <Subtitle variants={itemVariants}>
                    {content.subtitle}
                </Subtitle>
            </HeroSection>

            <ContentSection
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, margin: "-100px" }}
            >
                {/* Our Story Section with Founder Image */}
  {/* Our Story Section with Founder Image */}
<Section variants={itemVariants}>
    <SectionTitle>Our Story</SectionTitle>
    <SectionContent reverse={false}>
        <TextContent>
            <p>
                Founded with a vision to revolutionize the digital landscape, <strong>VVV IT Solutions</strong> has emerged as a trusted partner for businesses seeking cutting-edge technology solutions. Our journey began with a simple yet powerful mission: to bridge the gap between complex business challenges and innovative technological solutions.
            </p>
            <p>
                Over the years, we've grown from a small startup to a comprehensive IT solutions provider, serving clients across various industries including government, healthcare, education, and enterprise sectors. Our commitment to excellence, innovation, and customer satisfaction has been the driving force behind our success.
            </p>
            <p>
                Under the leadership of our founder <strong>Shiv Naresh</strong>, we have successfully delivered numerous government and enterprise projects, establishing ourselves as a reliable technology partner in the digital transformation space. Our approach focuses on understanding each client’s unique goals and crafting solutions that drive measurable impact.
            </p>
            <p>
                What began as a small dream in a single room has today evolved into a dynamic organization powered by a team of passionate professionals. We specialize in <strong>web and mobile app development, AI-based solutions, cloud integration, cybersecurity, and enterprise automation</strong>, ensuring that our clients stay ahead in a rapidly changing digital world.
            </p>
            <p>
                At <strong>VVV IT Solutions</strong>, we believe that technology is not just about code—it’s about creating experiences, empowering people, and transforming businesses. Every line of code we write reflects our core values of <strong>trust, innovation, and excellence</strong>.
            </p>
            <p>
                As we continue to grow, our goal remains clear—to be a driving force in the digital revolution and to help organizations unlock their true potential through intelligent, scalable, and sustainable technology solutions.
            </p>
        </TextContent>

        <div>
            <ImageContainer
                whileHover={{ scale: 1.02 }}
                transition={{ duration: 0.3 }}
            >
                <img 
                    src={companyFounder} 
                    alt="Shiv Naresh - Founder & CEO of VVV IT Solutions"
                />
            </ImageContainer>

            <FounderInfo variants={itemVariants}>
                <h3>
                    <FaStar color="#FFC857" />
                    Shiv Naresh
                </h3>
                <p className="founder-role">
                    <FaAward color="var(--theme-accent)" />
                    Founder & CEO
                </p>
                <p>
                    Visionary leader and technology enthusiast with over 8 years of experience 
                    in software development and digital transformation. Shiv Naresh founded 
                    <strong> VVV IT Solutions</strong> with a mission to create impactful digital solutions 
                    that empower businesses and communities worldwide.
                </p>
                <p>
                    His leadership philosophy is built on innovation, transparency, and client trust. 
                    He continues to guide the company toward excellence, fostering a culture where 
                    creativity meets technology and ideas turn into transformative solutions.
                </p>
                <div className="contact-info">
                    <FaEnvelope />
                    <a href="mailto:shiv.naresh@vvvitsolutions.com">
                        shiv.naresh@vvvitsolutions.com
                    </a>
                </div>
                <div className="contact-info">
                    <FaLinkedin />
                    <a href="https://linkedin.com/in/shivnaresh" target="_blank" rel="noopener noreferrer">
                        Connect on LinkedIn
                    </a>
                </div>
            </FounderInfo>
        </div>
    </SectionContent>
</Section>

                {/* Our Mission Section - No Image */}
                <Section variants={itemVariants}>
                    <SectionTitle>Our Mission</SectionTitle>
                    <SectionContent reverse={true}>
                        <TextContent>
                            <p>
                                At <strong>VVV IT Solutions</strong>, our mission is to empower businesses with transformative digital solutions that drive growth, efficiency, and innovation. We believe in creating technology that not only solves immediate challenges but also paves the way for future success.
                            </p>
                            <p>
                                We strive to be more than just a service provider – we aim to be <em>strategic partners</em> in our clients' digital transformation journeys, helping them navigate the complexities of modern technology with confidence and clarity.
                            </p>
                            <p>
                                Our commitment extends beyond delivering code; we focus on understanding our clients' unique needs and providing solutions that create lasting value and competitive advantage in today's digital landscape.
                            </p>
                        </TextContent>
                        <TextContent>
                            <p>
                                <strong>We are dedicated to:</strong>
                            </p>
                            <MissionList>
                                <li>
                                    <FaCheck />
                                    <span>Delivering <strong>high-quality, scalable solutions</strong> that grow with your business</span>
                                </li>
                                <li>
                                    <FaCheck />
                                    <span>Providing <strong>expert guidance</strong> and technical expertise at every step</span>
                                </li>
                                <li>
                                    <FaCheck />
                                    <span>Ensuring <strong>timely delivery</strong> without compromising on quality</span>
                                </li>
                                <li>
                                    <FaCheck />
                                    <span>Building <strong>long-term partnerships</strong> based on trust and results</span>
                                </li>
                                <li>
                                    <FaCheck />
                                    <span>Staying at the <strong>forefront of technology</strong> to offer cutting-edge solutions</span>
                                </li>
                            </MissionList>
                        </TextContent>
                    </SectionContent>
                </Section>

                <Section variants={itemVariants}>
                    <SectionTitle>Our Values</SectionTitle>
                    <ValuesGrid>
                        {content.values.map((value, index) => (
                            <ValueCard
                                key={index}
                                variants={itemVariants}
                                whileHover={{ y: -5 }}
                                transition={{ delay: index * 0.1 }}
                            >
                                <ValueIcon className="value-icon">
                                    {value.icon}
                                </ValueIcon>
                                <ValueTitle>{value.title}</ValueTitle>
                                <ValueDescription>{value.description}</ValueDescription>
                            </ValueCard>
                        ))}
                    </ValuesGrid>
                </Section>

                <StatsSection variants={itemVariants}>
                    <SectionTitle style={{ color: 'white' }}>Our Impact</SectionTitle>
                    <StatsGrid>
                        <StatItem variants={itemVariants}>
                            <span className="stat-number">50+</span>
                            <div className="stat-label">Projects Completed</div>
                        </StatItem>
                        <StatItem variants={itemVariants}>
                            <span className="stat-number">15+</span>
                            <div className="stat-label">Products</div>
                        </StatItem>
                        <StatItem variants={itemVariants}>
                            <span className="stat-number">5+</span>
                            <div className="stat-label">Years Experience</div>
                        </StatItem>
                        <StatItem variants={itemVariants}>
                            <span className="stat-number">100%</span>
                            <div className="stat-label">Client Satisfaction</div>
                        </StatItem>
                    </StatsGrid>
                </StatsSection>

                <TeamSection variants={itemVariants}>
                    <SectionTitle>Our Team</SectionTitle>
                    <TeamContent>
                        <TextContent>
                            {content.teamDescription.split('\n').map((paragraph, i) => (
                                <p key={i}>{paragraph}</p>
                            ))}
                        </TextContent>
                    </TeamContent>
                </TeamSection>
            </ContentSection>
        </PageContainer>
    );
};

export default About;
